import { Service } from '@angular/core';

const ACCESS = 'accessToken';
const REFRESH = 'refreshToken';

@Service()
export class TokenStore {
  get access(): string | null {
    return this.read(ACCESS);
  }
  get refresh(): string | null {
    return this.read(REFRESH);
  }
  set(access: string, refresh?: string): void {
    try {
      localStorage.setItem(ACCESS, access);
      if (refresh) localStorage.setItem(REFRESH, refresh);
    } catch {
      /* storage unavailable */
    }
  }
  clear(): void {
    try {
      localStorage.removeItem(ACCESS);
      localStorage.removeItem(REFRESH);
    } catch {
      /* storage unavailable */
    }
  }
  private read(key: string): string | null {
    try {
      return localStorage.getItem(key);
    } catch {
      return null;
    }
  }
}
